export default "__VITE_ASSET__Bijp1Ts$__"